import { render, staticRenderFns } from "./ProposalCard.vue?vue&type=template&id=f74d6ece&scoped=true"
import script from "./ProposalCard.vue?vue&type=script&lang=js"
export * from "./ProposalCard.vue?vue&type=script&lang=js"
import style0 from "./ProposalCard.vue?vue&type=style&index=0&id=f74d6ece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74d6ece",
  null
  
)

export default component.exports